export default class UserAgent {
  constructor() {
    this.$html = $('html')
  }

  init() {
    this.removeNoscript()
    $('.dot-block').addClass('set-done')
  }

  removeNoscript() {
    $('#notify').remove()
  }

}

new UserAgent().init()
